import { UnknownAction } from 'redux'
import { ThunkAction } from 'redux-thunk'
import { RootState } from 'store/reducers/index.reducer'
import { CancelRefreshTokenExpired } from 'types/errorText'
import errorMessages from 'utilities/errorMessages'
import toast from 'utilities/toast/toast'

export type DispatchAction = {
    type: string
    payload: any
}

const createDispatchAction = (
    type: string,
    payload: any = null,
): DispatchAction => ({
    type,
    payload,
})

export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    UnknownAction
>

export default createDispatchAction

export type ThunkActionSet<PayloadType> = {
    onPending: string
    onSuccess: string
    onFailed: string

    pending: () => DispatchAction
    success: (payload?: PayloadType) => DispatchAction
    failed: (error?: any) => DispatchAction
}

export const createDispatchActionSet = <T = void>(
    actionName: string,
): ThunkActionSet<T> => {
    const pendingAction = actionName + '_PENDING'
    const successAction = actionName + '_SUCCESS'
    const failedAction = actionName + '_FAILED'

    return {
        onPending: pendingAction,
        onSuccess: successAction,
        onFailed: failedAction,
        pending: () => createDispatchAction(pendingAction),
        success: (payload?: T) => createDispatchAction(successAction, payload),
        failed: (error?: any) => createDispatchAction(failedAction, error),
    }
}

interface IFetchWithNotification<T> {
    apiLinkFnc: () => Promise<T>
    successMessage?: string
    errorMessage?: string
}

export const fetchWithNotification = async <T>({
    apiLinkFnc,
    successMessage,
    errorMessage,
}: IFetchWithNotification<T>): Promise<T> => {
    try {
        const result = await apiLinkFnc()

        if (successMessage) {
            toast.success(successMessage)
        }
        return result
    } catch (errorObj) {
        let { message: errorMessageRes, arg } = errorMessages(errorObj)

        if (errorMessage) {
            errorMessageRes = errorMessage
        }

        if (errorMessageRes !== CancelRefreshTokenExpired) {
            toast.error(errorMessageRes, arg)
        }
        throw errorObj
    }
}
